<template>
  <div>
    <div class="wrapper">
      <div class="" v-for="(item, index) in list" :key="index">
        <el-image
          :preview-src-list="[item.img]"
          :src="item.img"
          fit="cover"
        ></el-image>
        <p>{{ item.title }}</p>
      </div>
    </div>
    <p class="more" @click="more">
      {{ list.length == total ? '没有更多了' : '点击加载更多....' }}
    </p>
  </div>
</template>

<script>
import { cases } from '../utils/api'
export default {
  data() {
    return {
      list: [],
      page: 1,
      total: 0,
    }
  },
  created() {
    cases(
      { cate_id: this.$route.query.id, page: this.page, limit: 10 },
      (r) => {
        this.total = r.data.total
        this.list = r.data.data
      }
    )
  },
  methods: {
    more() {
      this.page++
      cases(
        { cate_id: this.$route.query.id, page: this.page, limit: 10 },
        (r) => {
          this.total = r.data.total
          this.list = this.list.concat(r.data.data)
        }
      )
    },
  },
  computed: {
    imgs() {
      return this.list.map((val) => {
        return val.img
      })
    },
  },
}
</script>

<style lang="less" scoped >
.wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 80px 0;
  display: flex;
  flex-wrap: wrap;
  & > div {
    width: 364px;
    height: 232px;
    margin-bottom: 40px;
    margin-right: 40px;
    display: flex;
    align-items: flex-end;
    cursor: pointer;
    position: relative;
    p {
      width: 100%;
      line-height: 40px;
      text-align: center;
      background: rgba(0, 108, 143, 0.6);
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      position: relative;
      z-index: 1;
    }
    .el-image {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  & > div:nth-child(3n) {
    margin-right: 0;
  }
}
.more {
  text-align: center;
  width: 100%;
  margin-bottom: 80px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909090;
  cursor: pointer;
}
@media (max-width: 767px) {
  .wrapper {
    width: 100%;
    padding: 0.34rem;
    justify-content: space-between;
    box-sizing: border-box;
    margin-top: 0.88rem;
    & > div {
      width: 48%;
      margin: 0;
      margin-bottom: 0.34rem;
      p {
        font-size: 0.24rem;
      }
    }
  }
  .more {
    font-size: 0.24rem;
    margin-bottom: 0.34rem;
  }
}
</style>